import styles from './news_details_item.module.scss';
import {AltButton} from '../../components/button/alt_button.tsx';
import {__} from '../../support/lang/translations.ts';
import {FlexRow} from '../../components/utility/flex_row.tsx';
import {Alignment} from '../../enums/alignment.ts';
import {NewsItemType} from '../../gql/pwa/graphql.ts';
import {formatDate} from '../../support/days_from_now.ts';
import {FlexColumn} from '../../components/utility/flex_column.tsx';

interface OwnProps {
    newsItem: NewsItemType;
    previousArticleId: number | null;
    nextArticleId: number | null;
}

export function NewsDetailsItem({newsItem, previousArticleId, nextArticleId}: OwnProps) {
    return (
        <div className={styles.news_details_item}>
            <div className={styles.news_details_item__content}>
                <div className={styles.content__title}>
                    <h2>{newsItem.title}</h2>
                    <span className={styles.title__date}>
                        {newsItem.publish_date ? formatDate(newsItem.publish_date) : null}
                    </span>
                </div>

                <div className={styles.content__content}>
                    <p className="leading">{newsItem.preface}</p>

                    <p dangerouslySetInnerHTML={{__html: newsItem.content ?? ''}}></p>
                </div>

                <div className={styles.content__footer}>
                    <FlexRow>
                        {previousArticleId ? (
                            <FlexColumn alignment={Alignment.Start}>
                                <AltButton to={`/news/${previousArticleId}`} inverse={true}>
                                    <i className={'fa-light fa-arrow-left'} />
                                    {__('news.detail.buttons.previous')}
                                </AltButton>
                            </FlexColumn>
                        ) : (
                            <span />
                        )}

                        {nextArticleId ? (
                            <FlexColumn alignment={Alignment.End}>
                                <AltButton to={`/news/${nextArticleId}`}>
                                    <i className={'fa-light fa-arrow-right'} />
                                    {__('news.detail.buttons.next')}
                                </AltButton>
                            </FlexColumn>
                        ) : (
                            <span />
                        )}
                    </FlexRow>
                </div>
            </div>
        </div>
    );
}
